module.exports = __webpack_public_path__ + "img/palmar-spa-3.2f999d47.jpg";